/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react';
import {BrowserRouter, Route, Switch, Redirect} from 'react-router-dom';

import {AppBar, Snackbar, fade, IconButton, InputBase, makeStyles, Toolbar, Menu, MenuItem} from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';

import { AppContext } from './stores/AppStore'
import { UserContext } from './stores/UserStore'

import PrivateRoute from './containers/router/PrivateRoute';

import RedirectTo from './pages/RedirectTo';
import Home from './pages/Home';
import ViewActivity from './pages/ViewActivity';
import ManageUsers from './pages/ManageUsers';
import ManageUser from './pages/ManageUser';
import ManageProfiles from './pages/ManageProfiles';
import SearchUsers from './pages/SearchUsers';

import Applications from './pages/Applications';
import Profiles from './pages/Profiles';
import Users from './pages/Users';
import Services from './pages/Services';

import SearchIcon from '@material-ui/icons/Search';

import LogoImg from './assets/images/logo-white.svg';

const useStyles = makeStyles((theme) => ({
    appBar: {
        // height: '72px',
        // backgroundColor: theme.palette.secondary.main,
        // boxShadow: '0 3px 6px 0 rgb(0 0 0 / 10%)'//'0px 2px 1px -1px rgb(0 0 0 / 10%), 0px 1px 1px 0px rgb(0 0 0 / 4%), 0px 1px 3px 0px rgb(0 0 0 / 2%)'
    },
    logoButton: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        width: '131px',
        height: '45px',
        cursor: 'pointer'
    },
    title: {
        flexGrow: 1,
        color: '#5a5a5aa3',
        fontWeight: 'bold'
    },
    search: {
      position: 'relative',
      borderRadius: theme.shape.borderRadius,
      backgroundColor: theme.palette.common.black,
      '&:hover': {
        backgroundColor: fade(theme.palette.common.black, 0.15),
      },
      marginRight: theme.spacing(2),
      marginLeft: 0,
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(3),
        width: 'auto',
      },
    },
    searchIcon: {
      padding: theme.spacing(0, 2),
      height: '100%',
      position: 'absolute',
      pointerEvents: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    inputRoot: {
      color: 'inherit',
    },
    inputInput: {
      fontSize: 16,
      fontWeight: 400,
      padding: theme.spacing(1, 1, 1, 0),
      // vertical padding + font size from searchIcon
      paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
      transition: theme.transitions.create('width'),
      width: '100%',
      [theme.breakpoints.up('md')]: {
        width: '35ch',
      },
    },
    grow: {
        flexGrow: 1,
    },
    section: {
        display: 'flex',   
    },
    userButton: {
        fontSize: 16,
        fontWeight: 600
    }

}));


const Alert = (props) => {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const Router = () => {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const isMenuOpen = Boolean(anchorEl);

    const { applicationMessage, setApplicationMessage, setApplicationSearchText } = useContext(AppContext);
    const { currentUser, signOut, refreshSession } = useContext(UserContext);
    const [searchText, setSearchText] = useState('');

    useEffect(() =>  {
        if (applicationMessage && applicationMessage.message && (applicationMessage.message.indexOf('Invalid Security Token') !== -1 || applicationMessage.message.indexOf('Unauthorized') !== -1)) {
            signOut();  
        } else
        if (applicationMessage && applicationMessage.message && applicationMessage.message.indexOf('Token Expired') !== -1) {
            refreshSession();  
        }
    }, [applicationMessage]);
    
    useEffect(() => {
        // console.log(searchText);
    }, [searchText]);
       
    const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const handleCloseMessage = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setApplicationMessage(null);
    };

    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.preventDefault();
        setSearchText(event.target.value);
    };

    const handleSearchKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter' && searchText) {
            setApplicationSearchText(searchText)
        }
    };

    return (
        <BrowserRouter>
            <AppBar position="static" classes={{root: classes.appBar}} color="transparent">
                <Toolbar variant="dense">
                    <img src={LogoImg} className={classes.logoButton} alt="Logo"/>
                    {/* <Typography variant="h5" className={classes.title}>
                        Security Manager
                    </Typography> */}
                    <div className={classes.grow} />

                    <div className={classes.search}>
                        <div className={classes.searchIcon}>
                            <SearchIcon />
                        </div>
                        <InputBase
                        placeholder="Search…"
                        classes={{
                            root: classes.inputRoot,
                            input: classes.inputInput,
                        }}
                        inputProps={{ 'aria-label': 'search' }}
                        onChange={handleSearchChange}
                        onKeyDown={handleSearchKeyDown}
                        />
                    </div>                    
                    <div className={classes.section}>
                        <IconButton
                            edge="end"
                            aria-label="Account of Current User"
                            aria-controls="user-account-menu"
                            aria-haspopup="true"
                            onClick={handleOpenMenu}
                            className={classes.userButton}>
                            {currentUser ? currentUser.firstName.substring(0,1) + '. ' + currentUser.lastName : ''}
                        </IconButton>
                    </div>
                </Toolbar>
            </AppBar>

            <Menu
                anchorEl={anchorEl}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                id="user-account-menu"
                keepMounted
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                open={isMenuOpen}
                onClose={handleCloseMenu}
                >
                <MenuItem onClick={handleCloseMenu}>{currentUser && currentUser.firstName + ' ' + currentUser.lastName}</MenuItem>
                <MenuItem onClick={signOut}>SignOut</MenuItem>
            </Menu>           

            <Snackbar open={applicationMessage ? true : false} autoHideDuration={6000} onClose={handleCloseMessage} anchorOrigin={{vertical: 'top', horizontal: 'center'} } style={{ width: '50%' }} >
                { applicationMessage && <Alert onClose={handleCloseMessage} severity={applicationMessage.type} style={{ width: '100%' }}>
                    {applicationMessage.message}
                </Alert> }
            </Snackbar>            
            <Switch>
                <Route path="/redirect/:to" exact>
                    <RedirectTo />
                </Route>
                <PrivateRoute path="/">
                    <Switch>
                        <PrivateRoute exact path='/'>
                            <Home />
                        </PrivateRoute>
                        <PrivateRoute exact path='/view-activity/:appId'>
                            <ViewActivity />
                        </PrivateRoute>
                        <PrivateRoute exact path='/manage/users/:appId'>
                            <ManageUsers />
                        </PrivateRoute> 
                        <PrivateRoute exact path='/manage/user/:appId/:userId'>
                            <ManageUser />
                        </PrivateRoute>
                        <PrivateRoute exact path='/manage/profiles/:appId'>
                            <ManageProfiles />
                        </PrivateRoute>                        
                        <PrivateRoute exact path='/search/users/:searchText'>
                            <SearchUsers />
                        </PrivateRoute>   
                        <PrivateRoute exact path='/applications'>
                            <Applications />
                        </PrivateRoute>
                        <PrivateRoute exact path='/applications/:act/:appId'>
                            <Applications />
                        </PrivateRoute>
                        <PrivateRoute exact path='/profiles'>
                            <Profiles />
                        </PrivateRoute>
                        <PrivateRoute exact path='/users'>
                            <Users />
                        </PrivateRoute>
                        <PrivateRoute exact path='/services'>
                            <Services />
                        </PrivateRoute>
                        <PrivateRoute path="/">
                            <Redirect to="/" />
                        </PrivateRoute>
                    </Switch>
                </PrivateRoute>
            </Switch>
        </BrowserRouter>
    )
};

export default Router;
